// import React, { useEffect, useState } from "react";
// import UserApi from "../../api/UserApi";
// import AddDetails from "./AddDetails";
// import EditDetails from "./EditDetails";
// import { formatDate } from "../../helpers/helper";
// import { showError, showSuccess } from "../../utils/toastUtils";
// import { Navigate } from "react-router-dom";

// import Auth from "../../utils/AuthUtils";
// import { can } from "../../utils/permissionUtils";

// const API_BASE = "http://localhost:5000"; // 🔥 change if needed

// function List() {
//   const [users, setUsers] = useState([]);
//   const [editData, setEditData] = useState(null);
//   const [deleteUser, setDeleteUser] = useState(null);
//   const [statusUser, setStatusUser] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [searchTerm, setSearchTerm] = useState("");

//   const userDetails = Auth.getUserDetails();
//   const permissions = userDetails?.permissions;

//   /* ================= FETCH USERS ================= */
//   const fetchUsers = async () => {
//     try {
//       setLoading(true);
//       const res = await UserApi.list();
//       if (res.code === 200) {
//         setUsers(res.data);
//       }
//     } catch {
//       showError("Failed to load users");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     if (can(permissions, "read", "user")) {
//       fetchUsers();
//     } else {
//       setLoading(false);
//     }
//   }, []);

//   /* ================= DELETE USER ================= */
//   const handleDelete = async () => {
//     if (!deleteUser?._id) return;

//     if (!can(permissions, "delete", "user")) {
//       showError("Access Denied");
//       return;
//     }

//     try {
//       const res = await UserApi.delete({ id: deleteUser._id });
//       if (res.code === 200) {
//         showSuccess(res.message);
//         fetchUsers();
//         setDeleteUser(null);
//         const modal = document.getElementById("delete_packages");
//         window.bootstrap?.Modal?.getInstance(modal)?.hide();
//       } else {
//         showError(res.message);
//       }
//     } catch {
//       showError("Delete failed");
//     }
//   };

//   /* ================= AUTH GUARD ================= */
//   if (!can(permissions, "read", "user")) {
//     return <Navigate to="/403" replace />;
//   }

//   if (loading) {
//     return (
//       <div className="p-5 text-center">
//         <h4>Loading User Directory...</h4>
//       </div>
//     );
//   }

// const handleStatusChange = async () => {
//   if (!statusUser?._id) return;

//   try {
//     const newStatus =
//       statusUser.status === "active"
//         ? "inactive"
//         : "active";

//     const res = await UserApi.updateStatus({
//       id: statusUser._id,
//       status: newStatus,
//     });

//     console.log("Status Update Response:", res);

//     if (res.code === 200) {
//       showSuccess(
//         res.message ||
//           `User ${newStatus === "active"
//             ? "activated"
//             : "deactivated"
//           } successfully`
//       );

//       fetchUsers();

//       setStatusUser(null);

//     } else {
//       showError(
//         res.message ||
//           "Failed to update user status"
//       );
//     }
//   } catch (error) {
//     console.error(
//       "Status update error:",
//       error?.response?.data || error
//     );

//     showError(
//       error?.response?.data?.message ||
//         "Failed to update user status"
//     );
//   }
// };

//   const filteredUsers = users.filter((item) => {
//     const search = searchTerm.toLowerCase().trim();

//     return (
//       item.name?.toLowerCase().includes(search) ||
//       item.email?.toLowerCase().includes(search) ||
//       item.phone?.toLowerCase().includes(search)
//     );
//   });

//   <div
//   className="modal fade"
//   id="status_confirmation_modal"
//   tabIndex={-1}
// >
//   <div className="modal-dialog modal-dialog-centered modal-sm">
//     <div className="modal-content border-0 shadow">
//       <div className="modal-body text-center p-4">

//         <div className="mb-3">
//           <span
//             className={`avatar avatar-xl rounded-circle ${
//               statusUser?.status === "active"
//                 ? "bg-warning-subtle text-warning"
//                 : "bg-success-subtle text-success"
//             }`}
//           >
//             <i
//               className={`ti fs-28 ${
//                 statusUser?.status === "active"
//                   ? "ti-user-off"
//                   : "ti-user-check"
//               }`}
//             />
//           </span>
//         </div>

//         <h5 className="mb-2">
//           {statusUser?.status === "active"
//             ? "Deactivate User?"
//             : "Activate User?"}
//         </h5>

//         <p className="text-muted small mb-4">

//           {statusUser?.status === "active" ? (
//             <>
//               Are you sure you want to deactivate{" "}
//               <b>{statusUser?.name}</b>?
//               <br />
//               The user will no longer be able to access the system.
//             </>
//           ) : (
//             <>
//               Welcome <b>{statusUser?.name}</b> back!
//               <br />
//               Are you sure you want to restore access to this account?
//             </>
//           )}

//         </p>

//         <div className="d-flex gap-2">

//           <button
//             type="button"
//             className="btn btn-light w-100"
//             data-bs-dismiss="modal"
//             onClick={() => setStatusUser(null)}
//           >
//             Cancel
//           </button>

//           <button
//             type="button"
//             className={`btn w-100 ${
//               statusUser?.status === "active"
//                 ? "btn-warning"
//                 : "btn-success"
//             }`}
//             onClick={handleStatusChange}
//           >
//             <i
//               className={`ti me-1 ${
//                 statusUser?.status === "active"
//                   ? "ti-user-off"
//                   : "ti-user-check"
//               }`}
//             />

//             {statusUser?.status === "active"
//               ? "Yes, Deactivate"
//               : "Yes, Activate"}
//           </button>

//         </div>

//       </div>
//     </div>
//   </div>
// </div>

//   const getAvatarUrl = (avatar) => {
//     if (!avatar) return null;

//     if (avatar.startsWith("http://") || avatar.startsWith("https://")) {
//       return avatar;
//     }

//     return `${API_BASE}${avatar.startsWith("/") ? avatar : `/${avatar}`}`;
//   };

//   {/* ================= STATUS CONFIRMATION MODAL ================= */}

//   return (
//     <div className="content pb-0">
//       {/* ================= HEADER ================= */}
//       <div className="d-flex align-items-center justify-content-between mb-4">
//         <h4>
//           User Management
//           <span className="badge bg-primary ms-2">{filteredUsers.length}</span>
//         </h4>
//       </div>

//       <div className="gap-2 d-flex align-items-center mb-3 justify-content-between flex-wrap">
//         <div className="group-search-box position-relative">
//           <i className="ti ti-search search-icon"></i>

//           <input
//             type="text"
//             className="form-control search-input"
//             placeholder="Search by Users..."
//             value={searchTerm}
//             onChange={(e) => setSearchTerm(e.target.value)}
//           />
//         </div>

//         {can(permissions, "write", "user") && (
//           <button
//             className="btn btn-primary"
//             data-bs-toggle="offcanvas"
//             data-bs-target="#offcanvas_add"
//           >
//             <i className="ti ti-user-plus me-1" />
//             Add User
//           </button>
//         )}
//       </div>

//       {/* ================= TABLE ================= */}
//       <div className="card shadow-sm border-0">
//         <div className="table-responsive">
//           <table className="table align-middle mb-0">
//             <thead className="table-light">
//               <tr>
//                 <th>S.no</th>
//                 <th>Avatar & Username</th>
//                 <th>Role</th>
//                 <th>Location</th>
//                 <th>Created</th>
//                 <th>Status</th>
//                 <th className="text-center">Action</th>
//               </tr>
//             </thead>

//             <tbody>
//               {users.length > 0 ? (
//                 filteredUsers.map((item, index) => (
//                   <tr key={item._id}>
//                     <td>{index + 1}</td>

//                     {/* USER DETAILS */}
//                     <td>
//                       <div className="d-flex align-items-center gap-3">
//                         {item.avatar ? (
//                           <img
//                             src={getAvatarUrl(item.avatar)}
//                             alt={item.name || "User"}
//                             className="rounded-circle shadow-sm"
//                             style={{
//                               width: "45px",
//                               height: "45px",
//                               objectFit: "cover",
//                               border: "2px solid #eee",
//                             }}
//                             onError={(e) => {
//                               e.currentTarget.onerror = null;
//                               e.currentTarget.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(
//                                 item.name || "User",
//                               )}&background=0D8ABC&color=fff&size=90`;
//                             }}
//                           />
//                         ) : (
//                           <div
//                             className="rounded-circle d-flex align-items-center justify-content-center text-white fw-bold"
//                             style={{
//                               width: "45px",
//                               height: "45px",
//                               background: "#0D8ABC",
//                               fontSize: "16px",
//                             }}
//                           >
//                             {item.name?.charAt(0).toUpperCase()}
//                           </div>
//                         )}

//                         <div>
//                           <div className="fw-semibold">{item.name}</div>
//                           <small className="text-muted">
//                             {item.email} | {item.phone}
//                           </small>
//                         </div>
//                       </div>
//                     </td>

//                     <td>
//                       <span className="badge bg-info text-dark">
//                         {item?.roleId?.role || "N/A"}
//                       </span>
//                     </td>

//                     <td>
//                       <i className="ti ti-map-pin me-1 text-muted"></i>
//                       {item.location || "—"}
//                     </td>

//                     <td>{formatDate(item.createdAt, true)}</td>

//                     {/* <td>
//                       <span
//                         className={`badge ${
//                           item.status === "active" ? "bg-success" : "bg-danger"
//                         }`}
//                       >
//                         {item.status}
//                       </span>
//                     </td> */}
//      <td>
//   <button
//     type="button"
//     className={`btn btn-sm ${
//       item.status === "active"
//         ? "btn-success"
//         : "btn-danger"
//     }`}
//     onClick={() => setStatusUser(item)}
//     disabled={!can(permissions, "write", "user")}
//   >
//     <i
//       className={`ti ${
//         item.status === "active"
//           ? "ti-user-check"
//           : "ti-user-off"
//       } me-1`}
//     />

//     {item.status === "active"
//       ? "Active"
//       : "Inactive"}
//   </button>
// </td>

//                     <td className="text-center">
//                       <div className="d-flex justify-content-center gap-2">
//                         {can(permissions, "write", "user") && (
//                           <button
//                             className="btn btn-outline-primary btn-sm"
//                             data-bs-toggle="offcanvas"
//                             data-bs-target="#offcanvas_edit"
//                             onClick={() => setEditData(item)}
//                           >
//                             <i className="ti ti-edit" />
//                           </button>
//                         )}

//                         {can(permissions, "delete", "user") && (
//                           <button
//                             className="btn btn-outline-danger btn-sm"
//                             data-bs-toggle="modal"
//                             data-bs-target="#delete_packages"
//                             onClick={() => setDeleteUser(item)}
//                           >
//                             <i className="ti ti-trash" />
//                           </button>
//                         )}
//                       </div>
//                     </td>
//                   </tr>
//                 ))
//               ) : (
//                 <tr>
//                   <td colSpan={7} className="text-center py-4">
//                     No users found
//                   </td>
//                 </tr>
//               )}
//             </tbody>
//           </table>
//         </div>
//       </div>

//       {/* ================= ADD OFFCANVAS ================= */}
//       <div
//         className="offcanvas offcanvas-end offcanvas-large"
//         tabIndex={-1}
//         id="offcanvas_add" style={{ overflow: "scroll" }}
//       >
//         <AddDetails fetchUsers={fetchUsers} />
//       </div>

//       {/* ================= EDIT OFFCANVAS ================= */}
//       <div
//         className="offcanvas offcanvas-end offcanvas-large"
//         tabIndex={-1}
//         id="offcanvas_edit"
//       >
//         <EditDetails data={editData} fetchUsers={fetchUsers} />
//       </div>

//       {/* ================= DELETE MODAL ================= */}
//       <div className="modal fade" id="delete_packages" tabIndex={-1}>
//         <div className="modal-dialog modal-dialog-centered modal-sm">
//           <div className="modal-content border-0 shadow">
//             <div className="modal-body text-center p-4">
//               <i className="ti ti-trash fs-2 text-danger mb-2" />
//               <h6>Confirm Delete</h6>
//               <p className="small text-muted">
//                 Delete <b>{deleteUser?.name}</b>?
//               </p>
//               <div className="d-flex gap-2">
//                 <button className="btn btn-light w-100" data-bs-dismiss="modal">
//                   Cancel
//                 </button>
//                 <button className="btn btn-danger w-100" onClick={handleDelete}>
//                   Delete
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//       {/* ================= STATUS CONFIRMATION MODAL ================= */}

// {statusUser && (
//   <>
//     <div
//       className="modal-backdrop fade show"
//       onClick={() => setStatusUser(null)}
//     />

//     <div
//       className="modal fade show"
//       style={{
//         display: "block",
//         zIndex: 1060,
//       }}
//       tabIndex={-1}
//       role="dialog"
//     >
//       <div className="modal-dialog modal-dialog-centered modal-sm">
//         <div className="modal-content border-0 shadow">

//           <div className="modal-body text-center p-4">

//             {/* ICON */}

//             <div className="mb-3">
//               <span
//                 className={`avatar avatar-xl rounded-circle ${
//                   statusUser.status === "active"
//                     ? "bg-warning-subtle text-warning"
//                     : "bg-success-subtle text-success"
//                 }`}
//               >
//                 <i
//                   className={`ti fs-28 ${
//                     statusUser.status === "active"
//                       ? "ti-user-off"
//                       : "ti-user-check"
//                   }`}
//                 />
//               </span>
//             </div>

//             {/* TITLE */}

//             <h5 className="mb-2">
//               {statusUser.status === "active"
//                 ? "Deactivate User?"
//                 : "Activate User?"}
//             </h5>

//             {/* MESSAGE */}

//             <p className="text-muted small mb-4">
//               {statusUser.status === "active" ? (
//                 <>
//                   Are you sure you want to deactivate{" "}
//                   <b>{statusUser.name}</b>?
//                   <br />
//                   The user will no longer be able to access the system, and
//                   their assigned leads will be safely redistributed to
//                   available active users.
//                 </>
//               ) : (
//                 <>
//                   Welcome <b>{statusUser.name}</b> back!
//                   <br />
//                   Are you sure you want to restore access to this account?
//                   Previously transferred leads will remain with their current
//                   assigned users.
//                 </>
//               )}
//             </p>

//             {/* BUTTONS */}

//             <div className="d-flex gap-2">

//               <button
//                 type="button"
//                 className="btn btn-light w-100"
//                 onClick={() => setStatusUser(null)}
//               >
//                 Cancel
//               </button>

//               <button
//                 type="button"
//                 className={`btn w-100 ${
//                   statusUser.status === "active"
//                     ? "btn-warning"
//                     : "btn-success"
//                 }`}
//                 onClick={handleStatusChange}
//               >
//                 <i
//                   className={`ti me-1 ${
//                     statusUser.status === "active"
//                       ? "ti-user-off"
//                       : "ti-user-check"
//                   }`}
//                 />

//                 {statusUser.status === "active"
//                   ? "Yes, Deactivate"
//                   : "Yes, Activate"}
//               </button>

//             </div>

//           </div>

//         </div>
//       </div>
//     </div>
//   </>
// )}
//     </div>
//   );
// }

// export default List;

import React, { useEffect, useState } from "react";
import UserApi from "../../api/UserApi";
import AddDetails from "./AddDetails";
import EditDetails from "./EditDetails";
import { formatDate } from "../../helpers/helper";
import { showError, showSuccess } from "../../utils/toastUtils";
import { Navigate } from "react-router-dom";

import Auth from "../../utils/AuthUtils";
import { can } from "../../utils/permissionUtils";

const API_BASE = "http://localhost:5000";

function List() {
  const [users, setUsers] = useState([]);
  const [editData, setEditData] = useState(null);
  const [deleteUser, setDeleteUser] = useState(null);
  const [statusUser, setStatusUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");

  const userDetails = Auth.getUserDetails();
  const permissions = userDetails?.permissions;

  /* ================= FETCH USERS ================= */

  const fetchUsers = async () => {
    try {
      setLoading(true);

      const res = await UserApi.list();

      if (res.code === 200) {
        setUsers(res.data);
      } else {
        showError(res.message || "Failed to load users");
      }
    } catch (error) {
      console.error("Fetch users error:", error?.response?.data || error);

      showError(error?.response?.data?.message || "Failed to load users");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (can(permissions, "read", "user")) {
      fetchUsers();
    } else {
      setLoading(false);
    }
  }, []);

  /* ================= DELETE USER ================= */

  const handleDelete = async () => {
    if (!deleteUser?._id) return;

    if (!can(permissions, "delete", "user")) {
      showError("Access Denied");
      return;
    }

    try {
      const res = await UserApi.delete({
        id: deleteUser._id,
      });

      if (res.code === 200) {
        showSuccess(res.message || "User deleted successfully");

        fetchUsers();

        setDeleteUser(null);

        const modal = document.getElementById("delete_packages");

        window.bootstrap?.Modal?.getInstance(modal)?.hide();
      } else {
        showError(res.message || "Failed to delete user");
      }
    } catch (error) {
      console.error("Delete user error:", error?.response?.data || error);

      showError(error?.response?.data?.message || "Delete failed");
    }
  };

  /* ================= STATUS CHANGE ================= */

  const handleStatusChange = async () => {
    if (!statusUser?._id) return;

    if (!can(permissions, "write", "user")) {
      showError("Access Denied");
      return;
    }

    try {
      const newStatus = statusUser.status === "active" ? "inactive" : "active";

      const res = await UserApi.updateStatus({
        id: statusUser._id,
        status: newStatus,
      });

      console.log("Status Update Response:", res);

      if (res.code === 200) {
        showSuccess(
          res.message ||
            `User ${
              newStatus === "active" ? "activated" : "deactivated"
            } successfully`,
        );

        await fetchUsers();

        setStatusUser(null);
      } else {
        showError(res.message || "Failed to update user status");
      }
    } catch (error) {
      console.error("Status update error:", error?.response?.data || error);

      showError(
        error?.response?.data?.message || "Failed to update user status",
      );
    }
  };

  /* ================= AVATAR URL ================= */

  const getAvatarUrl = (avatar) => {
    if (!avatar) return null;

    if (avatar.startsWith("http://") || avatar.startsWith("https://")) {
      return avatar;
    }

    return `${API_BASE}${avatar.startsWith("/") ? avatar : `/${avatar}`}`;
  };

  /* ================= SEARCH ================= */

  const filteredUsers = users.filter((item) => {
    const search = searchTerm.toLowerCase().trim();

    return (
      item.name?.toLowerCase().includes(search) ||
      item.email?.toLowerCase().includes(search) ||
      item.phone?.toLowerCase().includes(search)
    );
  });

  /* ================= AUTH GUARD ================= */

  if (!can(permissions, "read", "user")) {
    return <Navigate to="/403" replace />;
  }

  /* ================= LOADING ================= */

  if (loading) {
    return (
      <div className="p-5 text-center">
        <h4>Loading User Directory...</h4>
      </div>
    );
  }

  return (
    <div className="content pb-0">
      {/* ================= HEADER ================= */}

      <div className="d-flex align-items-center justify-content-between mb-4">
        <h4>
          User Management
          <span className="badge bg-primary ms-2">{filteredUsers.length}</span>
        </h4>
      </div>

      {/* ================= SEARCH + ADD ================= */}

      <div className="gap-2 d-flex align-items-center mb-3 justify-content-between flex-wrap">
        <div className="group-search-box position-relative">
          <i className="ti ti-search search-icon"></i>

          <input
            type="text"
            className="form-control search-input"
            placeholder="Search by Users..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>

        {can(permissions, "write", "user") && (
          <button
            className="btn btn-primary"
            data-bs-toggle="offcanvas"
            data-bs-target="#offcanvas_add"
          >
            <i className="ti ti-user-plus me-1" />
            Add User
          </button>
        )}
      </div>

      {/* ================= TABLE ================= */}

      <div className="card shadow-sm border-0">
        <div className="table-responsive">
          <table className="table align-middle mb-0">
            <thead className="table-light">
              <tr>
                <th>S.no</th>

                <th>Avatar & Username</th>

                <th>Role</th>

                <th>Location</th>

                <th>Created</th>

                <th>Status</th>

                <th className="text-center">Action</th>
              </tr>
            </thead>

            <tbody>
              {filteredUsers.length > 0 ? (
                filteredUsers.map((item, index) => (
                  <tr key={item._id}>
                    <td>{index + 1}</td>

                    {/* USER DETAILS */}

                    <td>
                      <div className="d-flex align-items-center gap-3">
                        {item.avatar ? (
                          <img
                            src={getAvatarUrl(item.avatar)}
                            alt={item.name || "User"}
                            className="rounded-circle shadow-sm"
                            style={{
                              width: "45px",
                              height: "45px",
                              objectFit: "cover",
                              border: "2px solid #eee",
                            }}
                            onError={(e) => {
                              e.currentTarget.onerror = null;

                              e.currentTarget.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(
                                item.name || "User",
                              )}&background=0D8ABC&color=fff&size=90`;
                            }}
                          />
                        ) : (
                          <div
                            className="rounded-circle d-flex align-items-center justify-content-center text-white fw-bold"
                            style={{
                              width: "45px",
                              height: "45px",
                              background: "#0D8ABC",
                              fontSize: "16px",
                            }}
                          >
                            {item.name?.charAt(0).toUpperCase()}
                          </div>
                        )}

                        <div>
                          <div className="fw-semibold">{item.name}</div>

                          <small className="text-muted">
                            {item.email} | {item.phone}
                          </small>
                        </div>
                      </div>
                    </td>

                    {/* ROLE */}

                    <td>
                      <span className="badge bg-info text-dark">
                        {item?.roleId?.role || "N/A"}
                      </span>
                    </td>

                    {/* LOCATION */}

                    <td>
                      <i className="ti ti-map-pin me-1 text-muted"></i>

                      {item.location || "—"}
                    </td>

                    {/* CREATED */}

                    <td>{formatDate(item.createdAt, true)}</td>

                    {/* STATUS */}

                    <td>
                      <button
                        type="button"
                        className={`btn btn-sm ${
                          item.status === "active"
                            ? "btn-success"
                            : "btn-danger"
                        }`}
                        onClick={() => setStatusUser(item)}
                        disabled={!can(permissions, "write", "user")}
                      >
                        <i
                          className={`ti ${
                            item.status === "active"
                              ? "ti-user-check"
                              : "ti-user-off"
                          } me-1`}
                        />

                        {item.status === "active" ? "Active" : "Inactive"}
                      </button>
                    </td>

                    {/* ACTION */}

                    <td className="text-center">
                      <div className="d-flex justify-content-center gap-2">
                        {can(permissions, "write", "user") && (
                          <button
                            className="btn btn-outline-primary btn-sm"
                            data-bs-toggle="offcanvas"
                            data-bs-target="#offcanvas_edit"
                            onClick={() => setEditData(item)}
                          >
                            <i className="ti ti-edit" />
                          </button>
                        )}

                        {can(permissions, "delete", "user") && (
                          <button
                            className="btn btn-outline-danger btn-sm"
                            data-bs-toggle="modal"
                            data-bs-target="#delete_packages"
                            onClick={() => setDeleteUser(item)}
                          >
                            <i className="ti ti-trash" />
                          </button>
                        )}
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={7} className="text-center py-4">
                    No users found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* ================= ADD OFFCANVAS ================= */}

      <div
        className="offcanvas offcanvas-end offcanvas-large"
        tabIndex={-1}
        id="offcanvas_add"
        style={{
          overflow: "scroll",
        }}
      >
        <AddDetails fetchUsers={fetchUsers} />
      </div>

      {/* ================= EDIT OFFCANVAS ================= */}

      <div
        className="offcanvas offcanvas-end offcanvas-large"
        tabIndex={-1}
        id="offcanvas_edit"
      >
        <EditDetails data={editData} fetchUsers={fetchUsers} />
      </div>

      {/* ================= DELETE MODAL ================= */}

      <div className="modal fade" id="delete_packages" tabIndex={-1}>
        <div className="modal-dialog modal-dialog-centered modal-sm">
          <div className="modal-content border-0 shadow">
            <div className="modal-body text-center p-4">
              <i className="ti ti-trash fs-2 text-danger mb-2" />

              <h6>Confirm Delete</h6>

              <p className="small text-muted">
                Delete <b>{deleteUser?.name}</b>?
              </p>

              <div className="d-flex gap-2">
                <button className="btn btn-light w-100" data-bs-dismiss="modal">
                  Cancel
                </button>

                <button className="btn btn-danger w-100" onClick={handleDelete}>
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ================= STATUS CONFIRMATION MODAL ================= */}

      {statusUser && (
        <>
          {/* BACKDROP */}

          <div
            className="modal-backdrop fade show"
            style={{
              zIndex: 1055,
            }}
            onClick={() => setStatusUser(null)}
          />

          {/* MODAL */}

          <div
            className="modal fade show"
            style={{
              display: "block",
              zIndex: 1060,
            }}
            tabIndex={-1}
            role="dialog"
            aria-modal="true"
          >
            <div className="modal-dialog modal-dialog-centered modal-sm">
              <div className="modal-content border-0 shadow">
                <div className="modal-body text-center p-4">
                  {/* ICON */}

                  <div className="mb-3">
                    <span
                      className={`avatar avatar-xl rounded-circle ${
                        statusUser.status === "active"
                          ? "bg-warning-subtle text-warning"
                          : "bg-success-subtle text-success"
                      }`}
                    >
                      <i
                        className={`ti fs-28 ${
                          statusUser.status === "active"
                            ? "ti-user-off"
                            : "ti-user-check"
                        }`}
                      />
                    </span>
                  </div>

                  {/* TITLE */}

                  <h5 className="mb-2">
                    {statusUser.status === "active"
                      ? "Deactivate User?"
                      : "Activate User?"}
                  </h5>

                  {/* MESSAGE */}

                  <p className="text-muted small mb-4">
                    {statusUser.status === "active" ? (
                      <>
                        Are you sure you want to deactivate{" "}
                        <b>{statusUser.name}</b>
                        ?
                        <br />
                        The user will no longer be able to access the system,
                        and their assigned leads will be safely redistributed to
                        available active users.
                      </>
                    ) : (
                      <>
                        Welcome <b>{statusUser.name}</b> back!
                        <br />
                        Are you sure you want to restore access to this account?
                        <br />
                        Previously transferred leads will remain with their
                        current assigned users.
                      </>
                    )}
                  </p>

                  {/* BUTTONS */}

                  <div className="d-flex gap-2">
                    <button
                      type="button"
                      className="btn btn-light w-100"
                      onClick={() => setStatusUser(null)}
                    >
                      Cancel
                    </button>

                    <button
                      type="button"
                      className={`btn w-100 ${
                        statusUser.status === "active"
                          ? "btn-warning"
                          : "btn-success"
                      }`}
                      onClick={handleStatusChange}
                    >
                      <i
                        className={`ti me-1 ${
                          statusUser.status === "active"
                            ? "ti-user-off"
                            : "ti-user-check"
                        }`}
                      />

                      {statusUser.status === "active"
                        ? "Yes, Deactivate"
                        : "Yes, Activate"}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default List;
